import {Exist} from "components/Exist";
import {HOCModal} from "components/HOCModal";
import {HOCModalCenterDesktopPosition} from "components/HOCModalCenterDesktopPosition";
import {useIsMobile} from "modules/utils/hooks";
import React, {Fragment, useState} from "react";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import {Storage} from "modules/utils";

const Wrapper = styled.div`
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
`;

// const Logo = styled.div`
// 	margin: 0 auto;
// 	display: block;
// 	max-width: 125px;
// 	min-height: 120px;
// 	padding-bottom: 30px;
// 	background: transparent;
// 	border: none;
// 	box-shadow: none;
// 	cursor: auto;
// 	img {
// 		width: 100%;
// 		height: 100%;
// 	}
// `;
//
const Controls = styled.div``;

// const Title = styled.p`
// 	font-weight: 800;
// 	font-size: 30px;
// 	line-height: 28px;
// 	text-align: center;
// `;
//
// const Description = styled.div`
// 	text-align: left;
// 	color: #ffff;
// 	font-size: 14px;
// 	max-width: 90%;
// 	width: 100%;
// 	padding: 20px;
// 	margin: 0 auto;
// 	ul {
// 		padding: 0 20px;
// 		li {
// 			list-style: disc;
// 			line-height: 1.8;
// 		}
// 	}
// `;

// interface IProps {
// 	onPass: () => void;
// }
const Input = styled.input`
	height: 40px;
	border-radius: 20px;
	padding: 0 10px;
	margin-bottom: 20px;
	min-width: 300px;

	&:focus {
		box-shadow: 0 0 3px 3px rgba(0, 200, 0, 1);
	}
`;

const Form = styled.form`
	display: flex;
	flex-flow: column;
	align-items: center;
	justify-content: center;
	button {
		width: 100%;
		height: 40px;
		border-radius: 20px;
		background: rgba(0, 200, 0, 1);
		box-shadow: none;
		border: none;
	}
`;

const SECONDARY_SECRET_KEY = "secondarySecretPassed";
const CONFIRM_PASS = "VxR34hsdIed699";

export const SecondarySecretModal: React.FC = () => {
	const i18n = useTranslation();
	const isMobile = useIsMobile();
	const [password, setPassword] = useState("");

	const onSubmit = (e: React.FocusEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (password === CONFIRM_PASS) {
			Storage.SET(SECONDARY_SECRET_KEY, true);
			window.location.reload();
		}
	};

	const onSetPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {value} = e.currentTarget;

		setPassword(value);
	};

	const Content = () => (
		<Wrapper>
			<Controls>
				<Form onSubmit={onSubmit}>
					<Input
						onChange={onSetPassword}
						defaultValue={password}
						name="password"
						type="text"
						placeholder="Please enter you password"
					/>
					<button type="submit">Submit</button>
				</Form>
			</Controls>
		</Wrapper>
	);

	const props = {
		isOpen: true,
		name: "secret-modal",
		headerText: (
			<Fragment>{i18n.t("coming_soon.header.secondary_title", "Please let me in!")}</Fragment>
		),
	};

	return (
		<Fragment>
			<Exist when={isMobile}>
				<HOCModal {...props} hideCrossButton={true}>
					<Content />
				</HOCModal>
			</Exist>
			<Exist when={!isMobile}>
				<HOCModalCenterDesktopPosition {...props}>
					<Content />
				</HOCModalCenterDesktopPosition>
			</Exist>
		</Fragment>
	);
};
